module.exports = __webpack_public_path__ + "img/bid-open-hall-center-border.a4b7ae77.png";